import { Component, OnInit, Input } from "@angular/core";
import { SolicitacaoService } from 'src/app/service/solicitacao/solicitacao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { ERRO_CONSULTAR_PROCESSO, MSG_OBG_NUM_PROCESSO, MSG_OBG_TIPO_JUSTICA } from './../../../../tools/Mensagens';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: "processo-solicitacao",
  templateUrl: "./processo-solicitacao.component.html",
  styleUrls: ["./processo-solicitacao.component.css"]
})
export class ProcessoSolicitacaoComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  checkedMarcado: boolean = false;
  listaClassificacaoComponente = [];
  listaTipoProcessoComponente = [];
  charNum = 5000;
  isNotNumber = false;
  isNotValidNumeroProcesso = false;
  isAntigoFormatoSolicitacao = false;

  constructor(
    public service: SolicitacaoService,
    public desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) {
  }

  ngOnInit() {

    //this.preencherListaClassificacao();
    //this.preencherListaTipoProcesso();

    if (!this.visualizacao && !this.edicao) {

      this.service.solicitacao.controls.descricaoSolicitacao.setValue('');
      //this.service.solicitacao.controls.numeroProcesso.setValue(null);
      //this.service.solicitacao.controls.comarca.setValue(null);
      //this.service.solicitacao.controls.vara.setValue(null);
      //this.service.solicitacao.controls.numeroINFOPEN.setValue(null);
      //this.service.solicitacao.controls.tipoDeJustica.setValue('');

    }

  }

  changeTipoJustica() {

    this.service.solicitacao.controls.numeroProcesso.enable();
    this.service.solicitacao.controls.numeroProcesso.setValue('');

  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.solicitacao.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.solicitacao.value.assunto.id);
  }

  preencherListaTipoProcesso() {
    this.listaTipoProcessoComponente = this.service.solicitacao.value.listaTipoProcessoCompleta;
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarOutrasOpcoes(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  checkTipoProcesso() {
    this.service.solicitacao.controls.listaTipoProcesso.setValue(this.listaTipoProcessoComponente.filter(ltp => ltp.selecionado));
  }

  atribuirListaClassificacao() {
    this.service.solicitacao.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.solicitacao.controls[str].touched &&
      this.service.solicitacao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

  maskNumeroProcesso(numeroProcesso) {

    numeroProcesso = numeroProcesso.trim().replace(/\./g, '').replace(/-/g, '');

    if (numeroProcesso.length >= 13 && numeroProcesso.charAt(13) !== '8') {

      this.isNotValidNumeroProcesso = true;

      return;

    } else if (numeroProcesso.length >= 14 && numeroProcesso.charAt(14) !== '1') {

      this.isNotValidNumeroProcesso = true;

      return;

    } else if (numeroProcesso.length >= 15 && numeroProcesso.charAt(15) !== '3') {

      this.isNotValidNumeroProcesso = true;

      return;

    }

    this.isNotValidNumeroProcesso = numeroProcesso.length > 20;

    if (numeroProcesso && numeroProcesso.length >= 20 && numeroProcesso.length < 25) {

      let value = numeroProcesso;
      let resultado: any;
      value = value.toString();
      value = value.replace('-', '');
      value = value.replace('.', '');

      resultado = value.split('');
      resultado.splice(7, 0, '-');
      resultado.splice(10, 0, '.');
      resultado.splice(15, 0, '.');
      resultado.splice(17, 0, '.');
      resultado.splice(20, 0, '.');
      value = resultado.join('');

      this.service.solicitacao.controls.numeroProcesso.setValue(value);

    }

  }

  validaNumeroProcesso() {

    const regra = /^[0-9]*$/;
    const numero = this.service.solicitacao.value.numeroProcesso.trim().replace(/\./g, '').replace(/-/g, '');

    if (this.service.solicitacao.value.numeroProcesso && numero !== '') {

      if (numero.match(regra)) {

        this.isNotNumber = false;

      } else {

        this.isNotNumber = true;
        this.service.solicitacao.controls.numeroProcesso.setValue(numero.substring(0, numero.length - 1));

      }

    }

  }

  isChecked(valor) {
    if (valor.descricao === 'Execução Penal') {
      if (valor.selecionado) {
        this.checkedMarcado = true;
      } else {
        this.listaTipoProcessoComponente.filter(lc => lc).map(lc => lc.selecionado = false);
        this.checkedMarcado = false;
      }
    }

    if (valor.descricao === 'Nenhuma das opções anteriores') {
      if (valor.selecionado) {
        this.checkedMarcado = false;
        this.listaTipoProcessoComponente.filter(lc => lc).map(lc => lc.selecionado = false);
      }
    }
  }

  buscarProcesso() {

    if (!this.isNotValidNumeroProcesso) {

      if (this.service.solicitacao.value.tipoDeJustica === '' || this.service.solicitacao.value.tipoDeJustica == null) {
        alert(MSG_OBG_TIPO_JUSTICA);
      } else if (this.service.solicitacao.value.numeroProcesso === '' || this.service.solicitacao.value.numeroProcesso == null) {
        alert(MSG_OBG_NUM_PROCESSO);
      } else {
        this.service.buscarProcesso().subscribe(retorno => {
          if (retorno.comarca && retorno.vara) {
            this.service.solicitacao.controls.comarca.setValue(retorno.comarca);
            this.service.solicitacao.controls.vara.setValue(retorno.vara);
          } else {
            alert(ERRO_CONSULTAR_PROCESSO);
          }
        });
      }

    }

  }
}
